import requester from '@/lib/axios';
import { ProjectCourseFlagEnum } from '@/models/Flag';
import { Winner, WinnerCreate } from '@/models/Hackathon';
import { BaseFilters, ListServiceFunc } from '@/models/Service';

export type WinnerFilters = BaseFilters & {
  rank?: number;
  hackathonId?: number;
  category?: ProjectCourseFlagEnum[];
};

export const listWinners: ListServiceFunc<
  Winner,
  WinnerFilters
> = async params => {
  const { data } = await requester().get(`winners/`, {
    params,
  });
  return data;
};

export const createWinner = async (winner: WinnerCreate) => {
  const { data } = await requester().post<Winner>('winners/', winner);
  return data;
};

export const updateWinner = async (
  winnerId: number,
  winner: Partial<WinnerCreate>,
) => {
  const { data } = await requester().patch<Winner>(
    `winners/${winnerId}/`,
    winner,
  );
  return data;
};

export const deleteWinner = async (winnerId: number) => {
  const { data } = await requester().delete(`winners/${winnerId}/`);
  return data;
};
